define.alias("shared/modifiers/load-image-async", "media/modifiers/load-image-async");